import { mapDataSource, RawDataSource } from '~/Api/DataSource';
import { ReferencedProduct } from '~/Api/User/ProductGroup/LtMaxPrice/ReferencedProduct';
import Price from '~/utils/Price';

export interface RawReferencedProduct {
	id: string;
	currentExFactoryPrice: Price | null;
	dataSource: RawDataSource;
}

export const mapReferencedProduct = (product: RawReferencedProduct): ReferencedProduct => {
	return {
		id: product.id,
		currentExFactoryPrice:
			product.currentExFactoryPrice !== null
				? new Price(product.currentExFactoryPrice.value, product.currentExFactoryPrice.currency)
				: null,
		dataSource: mapDataSource(product.dataSource),
	};
};
